import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import Button from '../../../../core/modules/common/components/Button';
import { getCurrentReport, getUserType } from '../../../user/redux/selectors/UserReportSelectors';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData } from '../redux/actions/ReportsActions';
import { getReportCustomFilter } from '../redux/selectors/ReportsSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from '../../../wizard/period-selector/redux/selectors/PeriodSelectionSelectors';

class ReportCustomFiltersComparative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referencePeriod: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
    };
    this.onStartDateChange = this.onStartDateChange.bind(this);
  }

  onStartDateChange = (selected) => {
    const formattedSelected = moment(selected).format('YYYY-MM-DD');
    this.setState({
      referencePeriod: {
        from: formattedSelected,
        // eslint-disable-next-line react/no-access-state-in-setstate
        to: this.state.referencePeriod.to,
      },
    });
  };

  onEndDateChange = (selected) => {
    const formattedSelected = moment(selected).format('YYYY-MM-DD');
    this.setState({
      referencePeriod: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        from: this.state.referencePeriod.from,
        to: formattedSelected,
      },
    });
  };

  apply = () => {
    this.loadReport({ ...this.state });
  };

  loadReport = (state) => {
    const { reportCode } = this.props.currentReport;
    const report = ReportDefinitions[reportCode];
    const selectionCriteria =
      new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    this.props.reportLoadData(report, reportCode, {
      ...selectionCriteria,
      ...state,
    });
    this.setState(state);
  };

  formatDate = date => moment(date).format('DD/MM/YYYY');

  render() {
    const today = moment().format('DD/MM/YYYY');
    return (
      <div className="custom-filter-list">
        <div className="comparative-container">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            Reference Period:
          </label>
          <DayPickerInput
            value={today}
            formatDate={this.formatDate}
            onDayChange={this.onStartDateChange}
          /> to
          <DayPickerInput
            dayPickerProps={{
              modifiers: {
                disabled: [
                  {
                    before: new Date(this.state.referencePeriod.from),
                  },
                ],
              },
            }}
            value={today}
            formatDate={this.formatDate}
            onDayChange={this.onEndDateChange}
          />
          <Button onClick={this.apply} text="filter-component.action.apply" />
        </div>
      </div>
    );
  }
}

ReportCustomFiltersComparative.propTypes = {
  currentReport: PropTypes.objectOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportLoadData,
  }, dispatch);

const mapStateToProps = state => ({
  currentReport: getCurrentReport(state),
  currentUserType: getUserType(state),
  selectionCriteria: getSelectionCriteria(state),
  customFilter: getReportCustomFilter(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCustomFiltersComparative);
